import { Role } from './role';
import {Country} from "./country";


export const TYPE_USER = {
  CLIENT: 1,
  PROVIDER: 2,
  INTERNAL: 3,
  TELEDOCTOR_CLIENT: 4,
  TELEDOCTOR_DOCTOR: 5,
  ASSISTANCE_PROVIDER: 6,
  INSURANCE_EXT: 7,
  MEDICAL_EXPENSES: 9,
  SDS: 10
};



export class User {
  id?: number;
  email?: string;
  name?: string;
  username?: string;
  password?: string;
  roles?: Role[];
  ui_language?: string;
  scope_country_id?: number;
  scope_sponsor_id?: number;
  scope_agency_id?: number;
  scope_product_id?: number;
  updated_time?: string;
  created_time?: string;
  scope_country?: Country;
  is_medical_provider?: boolean;
  status: number;
  user_type:number;
  photo?:string;
  country_id?:number;
  allow_company_sap?: string | null;
  login_failed_amount?:number;
  phone_number?:string;
  national_id?:string;
  provider_id?:number;
  assistance_svcs?:any;
  providers_svcs?:any;
  campaign_id?:number;
  member_id?:number;
  applies_double_authentication_factor?:any;
  secret?:any;
  site_id?:number;
  sites?:any[];
  user_services?:any[];
  odontoprev_code?:number;

  // helper for edit provider of user type 10
  providerUser?:any=null;

  //product Coverage data of user
  product_data?:any;
  removed_products?:any;

  assistance_broker_id?: number;
  collaborator_code?: string;
  state_id?: number;
  phone2?: string;
  state?: any;
}
